import { render, staticRenderFns } from "./TreexV2.vue?vue&type=template&id=0ff6c880&scoped=true&"
import script from "./TreexV2.vue?vue&type=script&lang=js&"
export * from "./TreexV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff6c880",
  null
  
)

export default component.exports